import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-ink-900 px-5 py-14 sm:px-8 sm:py-20" data-id="element-314" data-mp="2x08gi0u8f7o3">
      <div className="mx-auto max-w-5xl" data-id="element-315" data-mp="2szycuutwwtce">
        <SectionHeading title="Master System of TRT™" subtitle="Everything you need to navigate TRT in one organized clinical system." data-id="element-316" data-mp="2sywt81ytyyj2" />

        <div className="mx-auto mt-6 max-w-2xl space-y-1.5 text-center text-[15px] text-white/70 sm:text-base" data-id="element-317" data-mp="2j9d62k434iie">
          <p data-id="element-318" data-mp="2ebttrpqy6ft3">This isn’t another textbook to leave sitting on your shelf.</p>
          <p data-id="element-319" data-mp="29bz39nb33s8k">It’s not a 20-hour course you’ll never finish.</p>
          <p data-id="element-320" data-mp="299mbkifiy3ib">And it’s not a random collection of scientific articles.</p>
        </div>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15px] leading-relaxed text-white sm:text-base" data-id="element-321" data-mp="259kgis4ao8c0">
          The Master System of TRT™ is a practical clinical reference designed to organize the TRT
          decision-making process — from the initial evaluation to treatment selection, monitoring,
          adjustment, and reassessment.
        </p>

        <p className="mt-8 text-center font-display text-base font-bold uppercase leading-tight tracking-[0.12em] text-teal-300 sm:text-xl" data-id="element-322" data-mp="2u5qymrut40fq">
          One system. Six clinical volumes.
          <br className="sm:hidden" data-id="element-323" data-mp="3lvlznls11ek8" /> One complete TRT pathway.
        </p>

        <h3 className="mt-12 text-center font-display text-2xl font-bold uppercase tracking-tight text-white sm:text-3xl" data-id="element-324" data-mp="3luay7sm20iwa">
          Inside the Master System of TRT™
        </h3>
        <p className="mt-2 text-center text-sm text-white/60 sm:text-base" data-id="element-325" data-mp="3cv60goibgtl6">
          6 Clinical Volumes Designed Around the Complete TRT Journey
        </p>

        <div className="mt-8 grid gap-4 sm:gap-5 lg:grid-cols-2" data-id="element-326" data-mp="21g0rj2rldyt4">
          {volumes.map(volume => <article key={volume.number} className="flex flex-col rounded-2xl border border-white/10 bg-ink-800/70 p-5 sm:p-6" data-id="element-327" data-mp="26geq7u7azweh">
              <p className="font-display text-xs font-bold uppercase tracking-[0.24em] text-teal-300" data-id="element-328" data-mp="70bwlnv4c85g">
                Volume {volume.number}
              </p>
              <h4 className="mt-2 font-display text-xl font-bold uppercase leading-tight text-white sm:text-2xl" data-id="element-329" data-mp="27it13bdz5uy">
                {volume.title}
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-white/70 sm:text-[15px]" data-id="element-330" data-mp="3pf2wysbxkoz6">
                {volume.intro}
              </p>
              {volume.lead ? <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.14em] text-white/45" data-id="element-331" data-mp="3fflsge8f0h4s">
                  {volume.lead}
                </p> : null}
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-332" data-mp="3bgcx54xq8b74">
                {volume.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-333" data-mp="19mx98ft0xafu">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-400" aria-hidden="true" data-id="element-334" data-mp="19not4td9djqa" />
                    <span className="text-[13px] leading-snug text-white/85 sm:text-sm" data-id="element-335" data-mp="2witsegqf08tg">
                      {item}
                    </span>
                  </li>)}
              </ul>
              {volume.footer ? <p className="mt-auto pt-4 text-[13px] font-semibold italic leading-snug text-teal-200 sm:text-sm" data-id="element-336" data-mp="35b5clkuxr00z">
                  {volume.footer}
                </p> : null}
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-337" data-mp="2hmm537jpmr9y">
          <CtaButton label="Get the 6 Clinical Volumes" subLabel="Instant Digital Access · USD 27 One-Time" data-id="element-338" data-mp="2hkt0rywkkj54" />
        </div>
      </div>
    </section>;
}